"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const MilestoneAwardManifest_1 = require("@/client/MilestoneAwardManifest");
const playerSymbol_1 = require("@/client/utils/playerSymbol");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'Award',
    props: {
        award: {
            type: Object,
            required: true,
        },
        showScores: {
            type: Boolean,
            default: true,
        },
        showDescription: {
            type: Boolean,
        },
    },
    methods: {
        playerSymbol(color) {
            return (0, playerSymbol_1.playerSymbol)(color);
        },
    },
    computed: {
        nameCss() {
            return 'ma-name--' + this.award.name.replace(/ /g, '-').replace(/\./g, '').toLowerCase();
        },
        sortedScores() {
            return [...this.award.scores].sort((s1, s2) => s2.score - s1.score);
        },
        description() {
            return (0, MilestoneAwardManifest_1.getAward)(this.award.name).description;
        },
    },
});
